import { createContext } from 'react';

const ColorModeContext = createContext({
  toggleColorMode: () => {
    // This is left blank intentionally - to be overridden
  },
  colorMode: () => {
    // This is left blank intentionally - to be overridden
  }
});

export { ColorModeContext }